export default function () {
    return {
        type: 'NEW_TRADE',
    }
}